if (!window.myakmNewsTickerReady) {
  window.myakmNewsTickerReady = true;
  const toggle = root => {
    const paused = root.dataset.paused !== 'true';
    const oldLabel = paused ? root.dataset.pauseLabel : root.dataset.resumeLabel;
    const newLabel = paused ? root.dataset.resumeLabel : root.dataset.pauseLabel;
    root.dataset.paused = String(paused);
    root.setAttribute('aria-pressed', String(paused));
    const label = root.getAttribute('aria-label');
    if (label && label.endsWith(oldLabel)) root.setAttribute('aria-label', label.slice(0, -oldLabel.length) + newLabel);
  };
  document.addEventListener('click', event => {
    const root = event.target.closest('[data-news-ticker]');
    if (root) toggle(root);
  });
  document.addEventListener('keydown', event => {
    const root = event.target.closest('[data-news-ticker]');
    if (!root || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    toggle(root);
  });
}
